/*
 *
 * ----------------------------------------------- */
// import StickySidebar from "sticky-sidebar";
import { isMobile } from "./isMobile";

$(window).on("load resize", function () {
  var $sectionWorks = $(".section-works");
  var sectionWorksHeight = $sectionWorks.height();

  if (!isMobile()) {
    if ($sectionWorks) {
      var windowHeight = $(window).height();
      $sectionWorks.css("height", sectionWorksHeight + windowHeight);
    }
  }
});
